export default {
  id: null,
  obraID: null,
  identificacao: null,
  selecionado: false,
  nome: null,
  detentora: null,
  idDetentora: null,
  latitude: null,
  longitude: null,
  altitude: null,
  cep: null,
  endereco: null,
  numero: null,
  complemento: null,
  bairro: null,
  cidade: null,
  estado: null,
  tipo: null // ,
  // equipamento: null
}



// WEBPACK FOOTER //
// ./src/shared/models/pci/constructioncandidate.js